import { Pipe, PipeTransform } from '@angular/core';
import { customer } from '../Model/customer';

@Pipe({
  name: 'CustomersFilter',
  standalone: false
})
export class CustomersFilterService implements PipeTransform {


  transform(customers: customer[], searchTerm: string, field: string): customer[] {
    if (!customers || !searchTerm) {

      return customers;
    }
    return customers.filter(customer =>
      customer.customerName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
  };
}



